import { create } from 'zustand'

const hasProAccess = (profile, sub) =>
  profile?.role === 'admin' ||
  profile?.role === 'moderator' ||
  profile?.is_pro === true ||
  sub?.status === 'active'

export const useAuthStore = create((set, get) => ({
  user: null,
  session: null,
  profile: null,
  subscription: null,
  isPro: false,
  subscriptionLoading: true,
  setUser: (user) => set({ user }),
  setSession: (session) => set({ session }),
  setProfile: (profile) => {
    const { subscription } = get()
    set({ profile, isPro: hasProAccess(profile, subscription) })
  },
  setSubscription: (sub) => {
    const { profile } = get()
    set({ subscription: sub, isPro: hasProAccess(profile, sub), subscriptionLoading: false })
  },
  isAdmin: () => {
    const state = useAuthStore.getState()
    return state.profile?.role === 'admin' || state.profile?.role === 'moderator'
  },
}))
